import React from 'react';
import { processFlow, images } from '../data/mock';

const ProcessSection = () => {
  return (
    <section id="process" className="section-padding" style={{ background: 'var(--bg-primary)' }}>
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
          <div className="lg:col-span-2">
            <div className="section-header" style={{ maxWidth: 'none' }}>
              <p className="section-label">Manufacturing Process</p>
              <h2 className="section-title">Precision at Every Step</h2>
              <p className="section-description">
                {processFlow.scope}. Our six-step process ensures consistent quality 
                from raw material to finished product.
              </p>
            </div>
          </div>
          <div className="image-overlay-container hidden lg:block" style={{ height: '200px' }}>
            <img 
              src={images.welding}
              alt={images.weldingAlt}
              className="img-cover"
              loading="lazy"
            />
            <div className="image-overlay" />
          </div>
        </div>

        <div className="process-grid">
          {processFlow.steps.map((step) => (
            <div key={step.step} className="process-step">
              <div className="process-number">0{step.step}</div>
              <h3 className="process-name">{step.name}</h3>
              <p className="process-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
